import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './MapLoading.scss';

export default function MapLoading() {
	return (
		<div className="home-search__map-loading">
			<FontAwesomeIcon icon={['far', 'spinner']} className="fa-pulse"/>
		</div>
	);
}
